export default __webpack_public_path__ + "static/media/avanto-logo.2899d701.png";